import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'Closing of the account is only possible at the request of the account holder. You can contact {accountHolderName} to make the closure request.',
    title: 'You cannot close the account',
  },
  fr: {
    body: 'La clôture du compte est possible uniquement sur demande du titulaire du compte. Vous pouvez vous rapprocher de {accountHolderName} pour effectuer la demande de clôture.',
    title: 'Vous ne pouvez pas clôturer le compte',
  },
});

export default locales;
